import { useT } from "../i18n";
import { FehlerBand, Knopf } from "./index";
import { istQualifikationsfrage } from "../daten/qualifikationsfrage";

/* ══════════════════════════════════════════════════════════════════
   Bediener ohne gültige Qualifikation — die Rückfrage (Migration 0230,
   Entscheidung E3/E17 vom 04.10.2026).

   Luca: *„Einstellbar in den Einstellungen, ob warnen oder sperren."*

   Steht der Betrieb auf **warnen**, antwortet die API beim Einplanen eines
   Bedieners `409 belegung.qualifikation_*`. Hier steht dann der Satz und
   „Trotzdem einplanen", das dieselbe Anfrage mit `qualifikation_bestaetigt`
   noch einmal schickt. Steht er auf **sperren**, kommt `422` — dann bleibt
   es beim Satz, ohne Knopf.

   Eine Form für alle Wege, auf denen ein Mensch an eine Position kommt:
   Bediener wählen, im Brett ziehen, Person tauschen.
   ══════════════════════════════════════════════════════════════════ */

export { istQualifikationsfrage };

/**
 * Der Fehler aus der API — und bei einer Rückfrage der Knopf, der es
 * trotzdem tut. Für jeden anderen Fehler das gewohnte Band.
 */
export function Qualifikationsband({ fehler, pfad, werte, trotzdem, laeuft }: {
  fehler: unknown;
  /** Ein eigener Pfad für die übrigen Fehler — wie bei `FehlerBand`. */
  pfad?: string | undefined;
  werte?: Record<string, string | number> | undefined;
  /** Schickt dieselbe Anfrage mit `qualifikation_bestaetigt: true`. */
  trotzdem: () => void;
  laeuft?: boolean;
}) {
  const t = useT();
  if (!istQualifikationsfrage(fehler)) {
    return <FehlerBand fehler={fehler} {...(pfad ? { pfad } : {})} {...(werte ? { werte } : {})} />;
  }
  return (
    <div className="qualifikationsfrage">
      <FehlerBand fehler={fehler} />
      <p className="nebensatz">{t("qualifikationsfrage.satz")}</p>
      <Knopf klein disabled={laeuft} onClick={trotzdem}>{t("qualifikationsfrage.trotzdem")}</Knopf>
    </div>
  );
}
